module.exports = __webpack_public_path__ + "static/raj_3-737377b682eb2aac7f8e078a46eb7cf4.jpg";